import {createGlobalStyle} from "styled-components";

const ProcessStyle = createGlobalStyle`

.process {
  width: 100%;
  padding: 0 15px;
  text-align: center;
}
.process__item {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  text-align: center;
  position: relative;
  padding: 15px 35px;
  -webkit-transition: 0.4s ease-in-out;
  transition: 0.4s ease-in-out;
}
.process__item:hover {
  background: #f99b44;
}
.process__item:hover .process__number {
  -webkit-transform: translateY(5px);
          transform: translateY(5px);
  color: #fff;
}
.process__item:hover .process__title {
transition: 0.4s ease-in-out;
  color: #fff;
}
.process__number {
  font-size: 90px;
  -webkit-text-stroke: 1px #f99b44;
  display: block;
  color: transparent;
  font-weight: 700;
  -webkit-transition: 0.4s ease-in-out;
  transition: 0.4s ease-in-out;
}
.process__title {
  display: block;
  font-weight: 700;
  letter-spacing: 1.5px;
  font-size: 35px;
  color: #f99b44;
  text-transform: uppercase;
  margin-top: 30px;
  transition: 0.4s ease-in-out;
}
.process__subtitle {
  display: block;
  font-size: 14px;
  color: #fff;
  margin-top: 30px;
  line-height: 1.5;
}
@media (min-width: 320px) and (max-width: 420px) {
  .process__item {
    padding:0
  }
}
@media (min-width: 320px) and (max-width: 991px) {
  .process__title {
    font-size: 25px
  }
}
@media (min-width: 768px) {
  .process {
    display: inline-block;
  }
  .process__item {
    width: 49%;
    display: inline-block;
  }
}
@media (min-width: 1200px) {
  .process {
    display: -webkit-box;
    display: inline-block;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-box-pack: justify;
    justify-content: space-between
  }
  .process__item {
    width: 50%;
  }

}


`;

export default ProcessStyle;
